const Catalogue = ($) => {
  const filtersWrapper = $(".wp-block-seven-shapes-catalogue__filters");
  $("button", filtersWrapper).on("click", (e) => {
    const currentCatalogue = $(e.currentTarget).parents(".wp-block-seven-shapes-catalogue");
    const filter = $(e.currentTarget).parents(".filter");

    // Radio : on désélectionne les autres button si si ils sont actifs
    if (filter.hasClass("filter--radio")) {
      $(e.currentTarget).siblings("button.active").toggleClass("active");
    }

    // On active le filtre cliqué
    $(e.currentTarget).toggleClass("active");

    // On filtre les offres
    const themeId = $(".filter--themes .active", currentCatalogue).data("theme-id");
    const publicId = $(".filter--publics .active", currentCatalogue).data("public-id");
    const niveauId = $(".filter--niveaux .active", currentCatalogue).data("niveau-id");

    const isFinancable = $("[data-boolean='financable']", currentCatalogue).hasClass("active");
    const isCertifiante = $("[data-boolean='certifiante']", currentCatalogue).hasClass("active");
    const isCPF = $("[data-boolean='cpf']", currentCatalogue).hasClass("active");

    let classes = ['.offre'];
    if (themeId) {
      classes.push(`.offre--theme-${themeId}`);
    }
    if (publicId) {
      classes.push(`.offre--public-${publicId}`);
    }
    if (niveauId) {
      classes.push(`.offre--niveau-${niveauId}`);
    }
    isFinancable ? classes.push(".offre--financable") : null;
    isCertifiante ? classes.push(".offre--certifiante") : null;
    isCPF ? classes.push(".offre--cpf") : null;

    $(".offre", currentCatalogue).hide();
    $(classes.join(""), currentCatalogue).show();
  });
};

export default Catalogue;
